import { SDK } from "@sdk";

import { iWACallLog } from "@sdk/wa-call-logs/wa-call-logs-model";
import { Store } from "redux";
import { QueryConfig } from "store/utils/query-config";
import { iStore } from "../../store.model";
import { CreateHelpersForEntity } from "../../utils/entity-slice-creator";
import { WACallLogsDefaultQueryConfig } from "./wa-call-logs-default-query";
import { WACallLogsSlice } from "./wa-call-logs.slice";

export const loadAllWACallLogs =
  () => async (store: Store<iStore>, forceReload?: boolean) => {
    await loadWACallLogsQuery(WACallLogsDefaultQueryConfig, "all")(
      store,
      forceReload,
    );
  };

export const generateWACallLogOfContactQuery = (contactId: string) => ({
  ...WACallLogsDefaultQueryConfig,
  query: {
    contactId,
  },
});

export const generateWACallLogOfRingAgentQuery = (ringAgentId: string) => ({
  ...WACallLogsDefaultQueryConfig,
  query: {
    ringAgents: ringAgentId,
  },
});

export const loadWACallLogOfContact =
  (contactId: string) =>
  async (store: Store<iStore>, forceReload?: boolean) => {
    await loadWACallLogsQuery(
      generateWACallLogOfContactQuery(contactId),
      JSON.stringify(generateWACallLogOfContactQuery(contactId)),
    )(store, forceReload);
  };

export const loadWACallLogOfRingAgent =
  (ringAgentId: string) =>
  async (store: Store<iStore>, forceReload?: boolean) => {
    await loadWACallLogsQuery(
      generateWACallLogOfRingAgentQuery(ringAgentId),
      JSON.stringify(generateWACallLogOfRingAgentQuery(ringAgentId)),
    )(store, forceReload);
  };

export const loadQueryWACallLogs =
  (queryConfig: QueryConfig, queryAlias?: string) =>
  async (store: Store<iStore>, forceReload?: boolean) => {
    queryAlias = queryAlias || JSON.stringify(queryConfig);
    await loadWACallLogsQuery(queryConfig, queryAlias)(store, forceReload);
  };

export const {
  loadEntityQueries: loadWACallLogsQuery,
  loadEntityById: loadWACallLogById,
  loadMoreEntityQueries: loadMoreWACallLogsQueries,
} = CreateHelpersForEntity<iStore, iWACallLog>({
  sliceName: "WACallLogs",
  slice: WACallLogsSlice,
  isPaginatedQueries: true,
  fetchPageSize: 50,
  loadEntityQueryProvider: (query) => SDK.WACallLogs.query(query),
  loadEntityByIdProvider: (entityId: string) =>
    SDK.WACallLogs.getById(entityId),
});
